document.addEventListener('DOMContentLoaded', () => {
  (function () {
    const slider = document.getElementById('mattress-slider');
    const slides = slider.querySelectorAll('.mattress-slide');
    const sliderNav = document.getElementById('mattress-sliderNav');
    const prevBtn = document.getElementById('mattress-prevBtn');
    const nextBtn = document.getElementById('mattress-nextBtn');
    const container = document.getElementById('mattress-sliderContainer');
    const thumbnails = document.querySelectorAll('#mattress-thumbnails .mattress-thumbnail-wrapper');
    const autoRotateDelay = 5000;

    const state = {
      currentIndex: 0,
      slideCount: slides.length,
      isAnimating: false,
      autoSlideTimer: null,
      loadedVideos: new Set(),
      touchStartX: 0,
    };

    const supportsPassive = (() => {
      let result = false;
      try {
        const opts = Object.defineProperty({}, 'passive', {
          get: function () {
            result = true;
          },
        });
        window.addEventListener('test', null, opts);
      } catch (e) { }
      return result;
    })();

    const passiveOpts = supportsPassive ? { passive: true } : false;

    // Video Management Functions
    function loadVideo(slideIndex) {
      if (state.loadedVideos.has(slideIndex)) return;

      const slide = slides[slideIndex];
      if (!slide || slide.dataset.slideType !== 'video') return;

      const videos = slide.querySelectorAll('.slide-video');
      const thumbnails = slide.querySelectorAll('.video-thumbnail');

      videos.forEach((video, index) => {
        const dataSrc = video.getAttribute('data-src');
        if (dataSrc && !video.src) {
          video.src = dataSrc;
          video.style.display = 'block';

          // Handle video loaded
          video.addEventListener('loadeddata', () => {
            if (thumbnails[index]) {
              thumbnails[index].style.opacity = '0';
              setTimeout(() => {
                thumbnails[index].style.display = 'none';
              }, 300);
            }
          }, { once: true });

          // Handle video load error
          video.addEventListener('error', () => {
            console.error(`Failed to load video: ${dataSrc}`);
            // Keep thumbnail visible if video fails to load
          }, { once: true });
        }
      });

      state.loadedVideos.add(slideIndex);
    }

    function pauseAllVideos() {
      slides.forEach(slide => {
        if (slide.dataset.slideType === 'video') {
          const videos = slide.querySelectorAll('.slide-video');
          videos.forEach(video => {
            if (!video.paused) {
              video.pause();
            }
          });
        }
      });
    }

    function playCurrentVideo() {
      const currentSlide = slides[state.currentIndex];
      if (!currentSlide || currentSlide.dataset.slideType !== 'video') return;

      const videos = currentSlide.querySelectorAll('.slide-video');
      setTimeout(function () {
        videos.forEach(video => {
          if (video.src) {
            video.removeAttribute('loop');
            pauseAutoSlide();

            if ((window.innerWidth > 767 && video.closest('.dekstop-visible')) || (window.innerWidth < 768 && video.closest('.mobile-visible'))) {
              var duration = parseInt(video.duration) || 15;
              var slideDelay = parseInt(autoRotateDelay / 1000);
              // console.log('video duration', slideDelay, duration);
              video.load();
              video.play().catch(error => {
                console.error('Failed to play video:', error);
              });

              if (slideDelay > duration) {
                startAutoSlide();
              }
              video.addEventListener('ended', () => {
                video.load();
                if (slideDelay > duration) {
                  video.play();
                } else {
                  nextSlide();
                  startAutoSlide();
                }
              });
            } else {
              video.pause();
            }
          }
        });
      }, 100);
    }

    // Lazy load videos that are coming up next
    function preloadAdjacentVideos() {
      const nextIndex = (state.currentIndex + 1) % state.slideCount;
      const prevIndex = (state.currentIndex - 1 + state.slideCount) % state.slideCount;

      [nextIndex, prevIndex].forEach(index => {
        const slide = slides[index];
        if (slide && slide.dataset.slideType === 'video') {
          loadVideo(index);
        }
      });
    }

    // Existing slider functions with video support
    function createDots() {
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < state.slideCount; i++) {
        const dot = document.createElement('div');
        dot.classList.add('mattress-nav-dot');
        if (i === 0) dot.classList.add('mattress-active');
        dot.dataset.index = i;
        fragment.appendChild(dot);
      }
      sliderNav.appendChild(fragment);
    }

    function updateSlider() {
      slider.style.transform = `translateX(-${state.currentIndex * 100}%)`;
      const dots = sliderNav.children;
      for (let i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('mattress-active', i === state.currentIndex);
      }

      // Pause all videos
      pauseAllVideos();

      // Load and play current video if it's a video slide
      const currentSlide = slides[state.currentIndex];
      if (currentSlide && currentSlide.dataset.slideType === 'video') {
        loadVideo(state.currentIndex);
        // Small delay to ensure video is loaded before playing
        setTimeout(() => {
          playCurrentVideo();
        }, 100);
      }

      // Preload adjacent videos
      setTimeout(preloadAdjacentVideos, 500);
    }

    function scrollButtonIntoView(index) {
      if (thumbnails[index]) {
        const activeButton = thumbnails[index];
        const container = document.getElementById('mattress-thumbnails');

        const buttonLeft = activeButton.offsetLeft;
        const buttonWidth = activeButton.offsetWidth;
        const containerWidth = container.offsetWidth;

        const scrollPosition = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);

        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    }

    function goToSlide(index) {
      startAutoSlide();
      if (state.isAnimating || index === state.currentIndex) return;
      state.isAnimating = true;
      state.currentIndex = index;
      updateSlider();

      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      if (thumbnails[index]) thumbnails[index].classList.add('active');

      scrollButtonIntoView(index);

      setTimeout(() => {
        state.isAnimating = false;
      }, 300);
    }

    function nextSlide() {
      if (state.isAnimating) return;
      goToSlide((state.currentIndex + 1) % state.slideCount);
    }

    function prevSlide() {
      if (state.isAnimating) return;
      goToSlide((state.currentIndex - 1 + state.slideCount) % state.slideCount);
    }

    function startAutoSlide() {
      clearInterval(state.autoSlideTimer);
      state.autoSlideTimer = setInterval(nextSlide, autoRotateDelay);
    }

    function pauseAutoSlide() {
      clearInterval(state.autoSlideTimer);
    }

    function handleTouchStart(e) {
      state.touchStartX = e.changedTouches[0].screenX;
    }

    function handleTouchEnd(e) {
      if (state.isAnimating) return;
      const diff = e.changedTouches[0].screenX - state.touchStartX;
      if (Math.abs(diff) < 50) return;
      diff < 0 ? nextSlide() : prevSlide();
    }

    function handleDotClick(e) {
      if (e.target.classList.contains('mattress-nav-dot') && !state.isAnimating) {
        const index = parseInt(e.target.dataset.index, 10);
        goToSlide(index);
      }
    }

    function handleVisibility() {
      if (document.hidden) {
        pauseAutoSlide();
        pauseAllVideos();
      } else {
        startAutoSlide();
        playCurrentVideo();
      }
    }

    // Handle intersection observer for better video loading
    function setupIntersectionObserver() {
      if (!window.IntersectionObserver) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const slideIndex = Array.from(slides).indexOf(entry.target);
            if (slideIndex !== -1 && entry.target.dataset.slideType === 'video') {
              loadVideo(slideIndex);
            }
          }
        });
      }, {
        root: container,
        threshold: 0.5
      });

      slides.forEach(slide => {
        if (slide.dataset.slideType === 'video') {
          observer.observe(slide);
        }
      });
    }

    function init() {
      createDots();

      // Setup intersection observer for video loading
      setupIntersectionObserver();

      // Load and play first slide video immediately if it's a video
      if (slides[0] && slides[0].dataset.slideType === 'video') {
        loadVideo(0);
        setTimeout(() => {
          playCurrentVideo();
        }, 100);
      }

      // Event listeners
      sliderNav.addEventListener('click', handleDotClick);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      });
      slider.addEventListener('touchstart', handleTouchStart, passiveOpts);
      slider.addEventListener('touchend', handleTouchEnd, passiveOpts);
      prevBtn.addEventListener('click', prevSlide);
      nextBtn.addEventListener('click', nextSlide);
      container.addEventListener('mouseenter', pauseAutoSlide);
      container.addEventListener('mouseleave', startAutoSlide);
      document.addEventListener('visibilitychange', handleVisibility);

      // Thumbnail click handlers
      thumbnails.forEach(thumb => {
        thumb.addEventListener('click', (e) => {
          const index = parseInt(e.currentTarget.dataset.index, 10);
          goToSlide(index);
        });
      });

      // Preload adjacent videos after initialization
      setTimeout(preloadAdjacentVideos, 1000);

      // Start auto slide
      startAutoSlide();
    }

    init();
  })();

  //events and redirection
  document.querySelectorAll('.mattress-pdp-main-banner .mattress-slide').forEach((slider, index) => {
    slider.addEventListener('click', function (e) {
      let targetVideo = null;
      if (window.innerWidth < 768) {
        targetVideo = e.currentTarget.querySelector('.mobile-visible video');
      } else {
        targetVideo = e.currentTarget.querySelector('.dekstop-visible video');
      }

      gaEvent('main_banner', [index, this.getAttribute('data-matt-src'), targetVideo?.src, '', '', ''], false);
      if (this.getAttribute('data-matt-src') != "") { window.location.href = this.getAttribute('data-matt-src'); }
    });
  })
});